import Badge from './Badge';

export type { BadgeProps, BadgeCssVars } from './Badge';

export default Badge;
